export default __webpack_public_path__ + "static/media/Media.2daaed4e.png";